const locale = require('./policiesSummary.i18n.json');

/*@ngInject*/
const PoliciesSummaryGridController = function ($filter, $controller, $rootScope, $scope, $state, $stateParams, $timeout, advancedFilterType, appTypeConfigurationModel, coreConstant, currencyUtil, submissionGridConstant, gridColumnModel, persistentConnection, submissionConstant, submissionMediator, uiPerformanceLoggerConstant, sortUtil) {

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));

    this.i18n = locale;

    let allPoliciesString = _.get(this.i18n, 'all'),
        timeoutList = [],
        policyParams = {
            key: 'policyEffectiveDate',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc',
            searchString: '',
            filterUri: ''
        };


    this.defaultFilter = {name: allPoliciesString};
    this.filterParams = {};
    this.tooltipDelay = 1000;
    this.advancedFilterType = advancedFilterType.POLICY_GRID;

    this.$onInit = function () {
        if (this.gridColumnsPreference) {
            this.columnPreference = this.gridColumnsPreference;
            policyParams.key = 'effectiveDate';
            policyParams.sortType = 'desc';
        } else {
            this.columnPreference = 'system.policyGridColumns';
        }
        this.selectedFilterName = this.getSelectedFilterName();
        this.uiPerformanceLogAction = uiPerformanceLoggerConstant.POLICY_SUMMARY_GRID;
        this.hasFilterPermission = true;
        this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
        this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
        this.requestParams = this.getFilterParams();

        this.onInitGridWidget();
    };

    this.loadRecords = function (onSuccess, onError) {
        if (this.requestParams.filterUri !== '') {
            this.submissionId = $stateParams.submissionId;
            if (_.isNil(this.selectedSubmissionIds)) {
                submissionMediator
                    .loadPolicies(this.submissionId, this.requestParams)
                    .then(this.extractFilterFromRecords.bind(this))
                    .then(this.applyFilterOnRecords.bind(this))
                    .then(this.updateTransactionDescriptions.bind(this))
                    .then(this.findCurrencyCode.bind(this))
                    .then(onSuccess, onError);
            } else if (this.selectedSubmissionIds.length > 0) {
                submissionMediator
                    .loadPoliciesBySubmissionIds(this.selectedSubmissionIds, this.requestParams)
                    .then(this.extractFilterFromRecords.bind(this))
                    .then(this.applyFilterOnRecords.bind(this))
                    .then(this.updateTransactionDescriptions.bind(this))
                    .then(this.findCurrencyCode.bind(this))
                    .then(onSuccess, onError);
            } else {
                onSuccess([]);
            }
        }
    };

    this.generateColumns = function () {
        this.colViewModel = gridColumnModel.getPoliciesGridColumns();
    };

    this.extractFilterFromRecords = function (records) {
        this.filters = [this.defaultFilter];
        let policyNumbers = _.uniq(_.map(records, function (i) {
            return i.policyNumber;
        }));

        _.each(policyNumbers.sort(), (policyNumber) => {
            this.filters.push({name: policyNumber});
        });

        this.setFilterParams();

        return records;
    };

    this.applyFilterOnRecords = function (records) {
        if ($stateParams.policyId) {
            records = _.filter(records, {owningPolicyId: _.parseInt($stateParams.policyId)});
        }

        if (_.has(this.requestParams, 'filter.name')) {
            records = _.filter(records, {policyNumber: _.get(this.requestParams, 'filter.name')});
        }

        return records;
    };

    this.updateTransactionDescriptions = function (records) {
        _.each(records, (record) => {
            if (record.transactionDescription) {
                if (_.includes(record.uri, 'EndorsementSummary')) {
                    record.transactionDescription = this.i18n.defaultEndorsementDescription + ' - ' + _.join(record.reasonList, ', ') + ' - ' + record.transactionDescription;
                }
            } else {
                if (_.includes(record.uri, 'PolicyIssuanceSummary')) {
                    record.transactionDescription = this.i18n.defaultIssuanceDescription;
                } else if (_.includes(record.uri, 'PolicyRewriteSummary')) {
                    if (record.reissue) {
                        record.transactionDescription = this.i18n.defaultReissueDescription;
                    } else {
                        record.transactionDescription = this.i18n.defaultRewriteDescription;
                    }
                } else if (_.includes(record.uri, 'PolicyCancellationSummary')) {
                    record.transactionDescription = this.i18n.defaultCancellationDescription;
                }
            }
        });

        const shouldReSortRecords = this.requestParams.key === 'transactionDescription';
        if (shouldReSortRecords) {
            this.sortUpdatedTransactionDescriptions(records);
        }

        return records;
    };

    /*
     * Set record.currencyCode so that baseGridWidgetController.loadGrid.onSuccess can find it.
     * This is necessary because PremiumChange does not have a currencyCode property.
     */
    this.findCurrencyCode = function (records) {
        _.each(records, (record) => {
            if (record.premiumChange) {
                record.currencyCode = record.premiumChange.currencyCode;
            } else if (record.annualPremium) {
                record.currencyCode = record.annualPremium.currencyCode;
            } else if (record.estimatedEarnedPremium) {
                record.currencyCode = record.estimatedEarnedPremium.currencyCode;
            }
        });
        return records;
    };

    this.sortUpdatedTransactionDescriptions = function (records) {
        records.sort(sortUtil.naturalSortObject(this.requestParams.key));

        if (this.requestParams.sortType === 'desc') {
            records.reverse();
        }
    };

    this.setFilterParams = function () {
        let selectedFilterName = gridColumnModel.getSelectedSubmissionFilterName(),
            filter = _.find(this.filters, ['name', selectedFilterName]);

        if (!_.isNil(filter) && _.get(filter, 'name') !== allPoliciesString) {
            policyParams.filter = filter;
        } else {
            policyParams.filter = null;
        }
    };

    this.getFilterParams = function () {
        return policyParams;
    };

    this.setSelectedFilterName = function (filterName) {
        gridColumnModel.setSelectedSubmissionFilterName(filterName);
    };

    this.getSelectedFilterName = function () {
        return gridColumnModel.getSelectedSubmissionFilterName();
    };

    this.calculateFilterParams = function () {};

    this.setDefaultGridValue = function () {
        allPoliciesString = _.get(this.i18n, 'all');
        this.defaultFilter = {name: allPoliciesString};
    };

    this.updateFilterFromPreferences = function () {
        this.setDefaultGridValue();
        this.filters = [this.defaultFilter];
        this.selectedFilterName = _.get(_.first(this.filters), 'name');
        this.setSelectedFilterName(this.selectedFilterName);
        policyParams.filterUri = 'com.firstbest.underwriting.filter.DefaultFilter:1';
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
    };

    this.navigateToItem = function (e, item) {
        let ownerUri = item.ownerUri;

        if (_.isNil(ownerUri)) {
            let ownerUriText = _.last(item.uri.split('.'));
            ownerUriText = _.replace(ownerUriText, ':', '/');
            ownerUriText = _.replace(ownerUriText, 'Summary', '');
            ownerUri = '/' + ownerUriText;
            if (_.startsWith(ownerUri, '/Policy') && parseInt($stateParams.submissionId) !== item.submissionId) {
                $state.go('submission.policy', {
                    submissionId: item.submissionId,
                    policyId: _.split(ownerUri, '/')[2]
                });
                return;
            }
        }
        $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, ownerUri);
    };

    function getCurrencyCode(policyChange, accessor) {
        let premiumObject,
            currencyCode;
        if (!_.isNil(policyChange.totalPremium)) {
            return currencyUtil.getCurrencyFormat(policyChange.totalPremium.currencyCode);
        }
        premiumObject = policyChange[accessor];
        if (!_.isNil(premiumObject) && premiumObject.currencyCode) {
            currencyCode = premiumObject.currencyCode;
        } else {
            premiumObject = policyChange[_.split(accessor, '.')[0]];
            if (!_.isNil(premiumObject) && premiumObject.currencyCode) {
                currencyCode = premiumObject.currencyCode;
            } else {
                return currencyUtil.getCurrencyFormat();
            }
        }
        return currencyUtil.getCurrencyFormat(currencyCode);
    }

    this.getValue = function (item, column) {
        let value,
            props,
            filter;
        props = [];
        if (column._accessor && column._accessor.indexOf('.' > 0)) {
            props = column._accessor.split('.');
        }
        else {
            props.push(column._accessor);
        }
        value = item;

        _.each(props, function (property) {
            if (!_.isNil(value)) {
                value = value[property];
            }
        });

        if (column._type && column._type.indexOf('shortDate') >= 0 ||
            column._accessor === 'paymentReceivedDate') {
            filter = $filter('utcDateFilter');
            value = filter(value, this.shortDateFormat, true);
        }
        if (column._type && column._type.indexOf('utcShortDate') >= 0 ||
            column._accessor === 'effectiveDate' ||
            column._accessor === 'expirationDate' ||
            column._accessor === 'nextTaskSummary.dueDate' ||
            column._accessor === 'receivedDate' ||
            column._accessor === 'quoteNeededByDate') {
            filter = $filter('utcDateFilter');
            value = filter(value, this.shortDateFormat);
        }

        const isPremium = column._type && column._type.indexOf('premium') >= 0;
        const isCurrency = column._type && column._type.indexOf('currency') >= 0;

        if (isPremium || isCurrency) {
            filter = $filter('currency');

            if (item.uri && item.uri.indexOf('PolicyIssuance') >= 0 && column._accessor === 'premiumChange') {
                value = '-';
            } else {
                let total,
                    symbol,
                    fractionSize = 0,
                    suffixSymbol = item.currencyFormat.suffixSymbol,
                    customFormat = item.currencyFormat.customFormat;

                if (isPremium) {
                    total = item[column._accessor] ? item[column._accessor].total : null;
                    symbol = item.currencyFormat.symbol;
                } else if (isCurrency) {
                    const currencyCode = getCurrencyCode(item, column._accessor);
                    total = (value && value.amount ? value.amount : (value && value.total ? value.total : value));
                    symbol = currencyCode.symbol;
                }

                if (total) {
                    value = filter(total, symbol, fractionSize, suffixSymbol, customFormat);
                } else {
                    value = '-';
                }
            }
        }

        if (column._type && column._type.indexOf('percent') >= 0) {
            value = _.round(value, 2) + '%';
        }

        if (column._accessor === 'numberOfClaims' && _.isNil(value)) {
            value = '0';
        }

        return value;
    };

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, () => {
        this.updateColumnsFromPreferences();
        this.resetGridColumns();
    });

    $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, () => {
        this.loadListOnFilterChange();
    });

    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, (evt, params) => {
        this.resetParams(params);
        if (this.isLoaded) {
            this.loadGrid();
        }
    });

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, () => {
        persistentConnection.connect().then(() => {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        });
    });

    $scope.$on(coreConstant.event.REFRESH_POLICY_CHANGE, (event, policyChange) => {
        let index = _.indexOf(this.records, _.find(this.records, {id: policyChange.id}));
        const isPremiumChange = !_.isNull(policyChange.premiumChange);

        policyChange = submissionMediator.processPolicyChangeStatus(policyChange);

        if(isPremiumChange) {
            policyChange.currencyFormat = currencyUtil.getCurrencyFormat(policyChange.premiumChange.currencyCode);
        }

        timeoutList.push($timeout(() => {
            if (index >= 0) {
                this.records.splice(index, 1, policyChange);
            }
            else if (policyChange.owningPolicyId === parseInt($stateParams.policyId)) {
                this.records.push(policyChange);
            }
        }, 0));
    });

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));

    $scope.$watch('$ctrl.selectedSubmissionIds', (newValue, oldValue) => {
        if (!_.isEqual(newValue, oldValue)) {
            this.loadGrid();
        }
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('gw-um-submission')
    .controller('policiesSummaryGridController', PoliciesSummaryGridController);
